import React from 'react';
import '../../css/SlideListSidebar.css';

function SlideListSidebar({ slides, currentSlide, submittedAnswers, onSlideSelect }) {
  return (
    <div className="offcanvas-body sidebar">
      <div className="sidebar-title">Slides</div>
      <div>
        {slides.map((slide, idx) => {
          const submission = submittedAnswers[idx];
          const isExercise = slide.exercise && slide.exercise.length > 0;

          return (
            <div
              key={idx}
              className={`sidebar-slide-item${idx === currentSlide ? ' active' : ''}`}
              onClick={() => onSlideSelect(idx)}
            >
              <span className={`sidebar-slide-bullet${idx === currentSlide ? ' active' : ''}`}>•</span>
              <span className={`sidebar-slide-heading${idx === currentSlide ? ' active' : ''}`}>{slide.heading}</span>
              {isExercise && submission && (
                <span className={submission.isCorrect ? "sidebar-slide-check correct" : "sidebar-slide-check incorrect"}>
                  {submission.isCorrect ? '✔' : '✖'}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SlideListSidebar;